import React, { useEffect, useState, useRef } from "react";
import "./AnimationOverlay.css";
import { setAnimationState } from "../navbar/Navbar";

interface AnimationOverlayProps {
    onAnimationComplete: () => void;
}

const AnimationOverlay: React.FC<AnimationOverlayProps> = ({
    onAnimationComplete,
}) => {
    const [showJ, setShowJ] = useState(false);
    const [showM, setShowM] = useState(false);
    const [showN, setShowN] = useState(false);
    const [showB, setShowB] = useState(false);
    const [startLogoTransition, setStartLogoTransition] = useState(false);
    const overlayRef = useRef<HTMLDivElement>(null);
    const timersRef = useRef<NodeJS.Timeout[]>([]);

    const abortAnimation = () => {
        // Clear all timers
        timersRef.current.forEach((timer) => clearTimeout(timer));
        timersRef.current = [];

        // Show all letters immediately
        setShowJ(true);
        setShowM(true);
        setShowN(true);
        setShowB(true);
        setStartLogoTransition(true);

        // Start fade out
        if (overlayRef.current) {
            overlayRef.current.classList.add("fade-out");
        }

        // Complete after fade out
        setTimeout(() => {
            setAnimationState(false);
            onAnimationComplete();
        }, 1500); // Give time for fade out to complete
    };

    useEffect(() => {
        // Initialize animation state
        setAnimationState(true);

        // Show letters one by one
        const jTimer = setTimeout(() => setShowJ(true), 1000);
        const mTimer = setTimeout(() => setShowM(true), 2000);
        const nTimer = setTimeout(() => setShowN(true), 3000);
        const bTimer = setTimeout(() => setShowB(true), 4000);

        // After all letters are shown, wait 2 seconds then start the logo transition
        const transitionTimer = setTimeout(() => {
            setStartLogoTransition(true);
        }, 6000);

        // Wait for the transition to complete (1.5s) before starting fade out
        const fadeOutTimer = setTimeout(() => {
            if (overlayRef.current) {
                overlayRef.current.classList.add("fade-out");
            }
        }, 7500);

        // Complete the animation and notify parent after fade-out is complete
        const completeTimer = setTimeout(() => {
            setAnimationState(false);
            onAnimationComplete();
        }, 9000);

        // Store all timers for cleanup
        timersRef.current = [
            jTimer,
            mTimer,
            nTimer,
            bTimer,
            transitionTimer,
            fadeOutTimer,
            completeTimer,
        ];

        return () => {
            timersRef.current.forEach((timer) => clearTimeout(timer));
            setAnimationState(false);
        };
    }, [onAnimationComplete]);

    return (
        <div
            ref={overlayRef}
            className="animation-overlay"
            onClick={abortAnimation}
        >
            <div
                className={`logo-container ${
                    startLogoTransition ? "transition-to-navbar" : ""
                }`}
            >
                <span className={`logo-letter ${showJ ? "visible" : ""}`}>
                    J
                </span>
                <span className={`logo-letter ${showM ? "visible" : ""}`}>
                    M
                </span>
                <span className={`logo-letter ${showN ? "visible" : ""}`}>
                    N
                </span>
                <span className={`logo-letter ${showB ? "visible" : ""}`}>
                    B
                </span>
            </div>
        </div>
    );
};

export default AnimationOverlay;
